import request from '../utils/request';
import cookies from 'js-cookie';

const user = cookies.get('user_id') || new Date().getTime();
export function report(parmas) {
    return request({
        method: "POST",
        url: `/mobile/report?user=${user}`,
        data: { ...parmas }
    })
}

export function submitOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/topup/v1/create',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

export function payOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/topup/v1/pay',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

export function getGoods(parmas, hearder) {
    return request({
        method: "POST",
        url: '/topup/v1/products',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

export function getAllOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/topup/v1/all',
        data: { ...parmas },
        headers: { ...hearder },
    })
}

export function getAvailOrder(parmas, hearder) {//首页获取待支付订单
    return request({
        method: "POST",
        url: '/topup/v1/topup_order',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

export function getSuccessOrder(parmas, hearder) {//根据订单号查询充值成功的订单信息
    return request({
        method: "POST",
        url: '/topup/v1/order',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

/* 
根据运营商查询充值卡商品
params:
    app_id:1
    vendor: VIETTEL/MOBIFONE/VINAPHONE
 */
export function getVoucherGoods(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/products',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

/* 
购买充值卡
params:
    "app_id":1,
    "user_id":"1234",
    "product_id":18,
    "quantity":1,
    "remark":"user remark"
 */
export function buyVoucher(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/create',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

/* 
查询充值卡订单
params:
    "app_id":1,
    "user_id":"1234",
    "LastMinId":"",
    "vendor":"VIETTEL",
    "page_size":5
 */
export function getAllVoucherOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/all',
        data: { ...parmas },
        headers: { ...hearder }
    })
}


/* 
查询已支付充值卡订单
params:
    "app_id":1,
    "user_id":"1234",
    "LastMinId":"",
    "vendor":"VIETTEL",
    "page_size":5
 */
export function getRechargedVoucherOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/avail',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

/* 
充值卡订单支付
params:
    "order_id":"1"
 */
export function payVoucherOrder(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/pay',
        data: { ...parmas },
        headers: { ...hearder }
    })
}

/* 
查询用户金币数量
params:
    "app_id":1,
    "user_id":"1"
 */
export function queryCoin(parmas, hearder) {
    return request({
        method: "POST",
        url: '/voucher/v1/coin',
        data: { ...parmas },
        headers: { ...hearder }
    })
}